<template>
  <div class="left-root">
    <VideoRoomHeader />
    <div class="left-bg">
      <div class="left-card">
        <div class="left-icon-wrap">
          <div class="left-icon">
            <img src="../assets/img/icons/icon-logout.svg" width="28" height="28" alt="" />
          </div>
        </div>

        <div class="left-card__content">
          <h1 class="left-card__title">{{ $t('title') }}</h1>
          <p class="left-card__text">{{ $t('description') }}</p>
        </div>

        <div class="left-card__footer">
          <button class="left-btn left-btn_secondary" @click="rejoin">
            {{ $t('rejoin') }}
          </button>
          <a :href="homeUrl" class="left-btn">
            {{ $t('action') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoRoomHeader from '@/components/VideoRoomHeader.vue';
import useHomeUrl from '@/compositions/useHomeUrl';

export default {
  name: 'VideoRoomLeft',
  components: { VideoRoomHeader },
  setup() {
    return {
      ...useHomeUrl(),
      rejoin: () => window.location.reload(),
    };
  },
};
</script>

<style lang="scss" scoped>
.left-root {
  min-height: 100vh;
  background: linear-gradient(160deg, #F0F4F8 0%, #EAF1F8 100%);
}

.left-bg {
  min-height: calc(100vh - 4rem);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 3rem;
}

.left-card {
  width: 100%;
  max-width: 26rem;
  background: #FFFFFF;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(10, 130, 217, 0.08), 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.5rem 2rem 2rem;

  &__content {
    margin-bottom: 2rem;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1A1A2E;
    margin: 0 0 0.625rem;
    line-height: 1.3;
  }

  &__text {
    font-size: 0.9rem;
    color: #6B8BAF;
    line-height: 1.6;
    margin: 0;
  }

  &__footer {
    width: 100%;
    border-top: 1px solid #F0F4F8;
    padding-top: 1.5rem;
    display: flex;
    gap: 0.75rem;
  }
}

.left-icon-wrap {
  margin-bottom: 1.5rem;
}

.left-icon {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(10, 130, 217, 0.08) 0%, rgba(0, 203, 243, 0.08) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0A82D9;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    border: 1.5px solid rgba(10, 130, 217, 0.15);
  }
}

.left-btn {
  flex: 1;
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #FFFFFF;
  text-decoration: none;
  border: none;
  cursor: pointer;
  white-space: pre-line;
  text-align: center;
  line-height: 1.3;
  background: linear-gradient(135deg, #0A82D9 0%, #00CBF3 100%);
  border-radius: 8px;
  padding: 0.65rem 1.5rem;
  box-shadow: 0 3px 10px rgba(10, 130, 217, 0.35);
  transition: box-shadow 0.25s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 5px 18px rgba(10, 130, 217, 0.45);
    transform: translateY(-1px);
    color: #FFFFFF;
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(10, 130, 217, 0.3);
  }

  &_secondary {
    background: transparent;
    color: #0A82D9;
    border: 1.5px solid rgba(10, 130, 217, 0.35);
    box-shadow: none;

    &:hover {
      background: rgba(10, 130, 217, 0.05);
      box-shadow: none;
      color: #0A82D9;
    }
  }
}

@media (max-width: 640px) {
  .left-bg {
    padding: 1rem 0.75rem;
    align-items: flex-start;
    padding-top: 2rem;
  }

  .left-card {
    padding: 2rem 1.5rem 1.5rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
title: You've left the meeting
description: You have successfully left the video interview. Thank you for your time.
rejoin: "Return\nto meeting"
action: "Go\nto Huntica"
</i18n>

<i18n locale="ru" lang="yaml">
title: Вы покинули встречу
description: Вы успешно вышли из видеособеседования. Спасибо за участие.
rejoin: "Вернуться\nк встрече"
action: "Перейти\nна Huntica"
</i18n>
